import { apolloClient } from '~/apollo-client';
import {
  Flex_FetchLmiZoneLookupQuery,
  Flex_FetchLmiZoneLookupQueryVariables,
} from '~/typings/graphql';
import { FETCH_LMI_ZONE_LOOKUP } from './fetch-lmi-zone-lookup.queries';

export type FetchLmiZoneOutlookParams = {
  utilityAccountId: number;
  // Optional address fields — when provided the LMI check runs against
  // this address instead of the address already saved on the UA.
  street?: string;
  city?: string;
  state?: string;
  zipCode?: string;
};

export type LmiZoneArea = {
  dacZone: boolean;
  empowerZone: boolean;
};

export type FetchLmiZoneOutlookResponse = {
  isInLmiArea: boolean;
  isInCensusTract: boolean;
  lmiZoneArea: LmiZoneArea;
  isAddressPresent: boolean;
  error: boolean;
};

export const fetchLmiZoneLookup = async (
  params: FetchLmiZoneOutlookParams,
): Promise<FetchLmiZoneOutlookResponse> => {
  const { data } = await apolloClient.query<
    Flex_FetchLmiZoneLookupQuery,
    Flex_FetchLmiZoneLookupQueryVariables
  >({
    query: FETCH_LMI_ZONE_LOOKUP,
    variables: {
      utilityAccountId: params.utilityAccountId,
      street: params.street,
      city: params.city,
      state: params.state,
      zipCode: params.zipCode,
    },
    fetchPolicy: 'no-cache',
  });

  const outlook = data.utilityAccount.lmiZoneLookup;

  if (!outlook) {
    throw new Error(`LMI zone lookup data is missing from the response: ${JSON.stringify(params)}`);
  }

  return {
    isInLmiArea: !!outlook.isInLmiArea,
    isInCensusTract: !!outlook.isInCensusTract,
    lmiZoneArea: {
      dacZone: !!outlook.lmiZoneArea?.dacZone,
      empowerZone: !!outlook.lmiZoneArea?.empowerZone,
    },
    isAddressPresent: !!outlook.isAddressPresent,
    error: !!outlook.error,
  };
};
